import { styled } from "@mui/material/styles";

export const Root = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const Title = styled("span")(() => ({
  color: "#1D2939",
  fontFamily: "Manrope",
  fontWeight: 700,
  lineHeight: "150%",
  fontSize: 18,
}));

export const CardRoot = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
}));

export const Card = styled("div")(() => ({
  padding: "4px 12px",
  display: "flex",
  alignItems: "center",
  gap: 8,
  border: "1px solid #e4e7ec",
  borderRadius: 8,
}));

export const CardTitle = styled("span")(() => ({
  color: "#9CA6AF",
  fontFamily: "Manrope",
  fontWeight: 600,
  lineHeight: "150%",
  fontSize: 16,
}));

export const CardDescription = styled("span")(() => ({
  color: "#465869",
  fontFamily: "Manrope",
  fontWeight: 700,
  lineHeight: "140%",
  fontSize: 18,
}));
